import { Input } from "antd";
import { useEffect, useState } from "react";
import { cn } from "utils/helper";

// WhatsApp melarang newline/tab di dalam variabel template — ratakan jadi spasi.
const sanitize = (value) => value.replace(/[\n\r\t]+/g, " ");

/**
 * Teks yang bisa diklik untuk diedit inline (berubah jadi input). Enter & Tab
 * ditolak; nilai final dibersihkan dari newline/tab. Dipakai di dalam bubble
 * pratinjau WhatsApp untuk mengedit ringkasan & tindak lanjut.
 */
const InlineEditableText = ({
  value,
  onChange,
  maxLength,
  placeholder = "",
  emptyText = "",
  ariaLabel,
  className = "",
  // Gaya saat nilai kosong; dipisah agar pemanggil bisa menandainya lebih tegas
  // (cn di sini hanya menggabung string, jadi kelas bentrok tak bisa ditimpa).
  emptyClassName = "italic text-neutral-400",
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");

  useEffect(() => {
    if (!editing) setDraft(value ?? "");
  }, [value, editing]);

  const startEdit = () => {
    setDraft(value ?? "");
    setEditing(true);
  };

  const commit = () => {
    onChange?.(sanitize(draft).trim());
    setEditing(false);
  };

  if (editing) {
    return (
      <Input.TextArea
        autoFocus
        autoSize
        value={draft}
        maxLength={maxLength}
        aria-label={ariaLabel}
        onChange={(e) => setDraft(sanitize(e.target.value))}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          }
          if (e.key === "Tab") {
            e.preventDefault();
          }
        }}
        onBlur={commit}
        className="!my-0.5 !text-sm"
      />
    );
  }

  const isEmpty = !value || !value.trim();

  return (
    <span
      role="button"
      tabIndex={0}
      title={placeholder}
      onClick={startEdit}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          startEdit();
        }
      }}
      className={cn(
        "cursor-text rounded-sm underline decoration-dotted decoration-neutral-400 underline-offset-2 transition-colors hover:bg-black/5",
        isEmpty && emptyClassName,
        className
      )}
    >
      {isEmpty ? emptyText || placeholder : value}
    </span>
  );
};

export default InlineEditableText;
